import {
  BrandCategoryBreakPoints,
  BrandHomeBreakPoints,
} from "@/constants/BreakPoints";
import { useRouter } from "next/router";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Link from "next/link";
import { handleStartWithSlashInUrl, validateImgSrc } from "@/utils/global";
import { v4 as uuidv4 } from "uuid";
import NextImage from "../NextImage";

const BrandSwiper = ({ data: fromHome, fromCategory = null, isNew }) => {
  const { locale } = useRouter();

  const data = fromHome
    ? [...(isNew ? fromHome?.value : fromHome)].map((item) => ({
        ...item,
        img: isNew
          ? item[`img-${locale}`]
          : `${process?.env?.NEXT_PUBLIC_IMG_BASEURL}/json/${
              item[`img-${locale}`]
            }`,
      }))
    : fromCategory?.map((item) => ({
        ...item,
        img: `${process?.env?.NEXT_PUBLIC_IMG_BASEURL}/catalog/category/${item?.brand_logo}`,
      }));

  return data?.length ? (
    <Swiper
      loop
      key={locale}
      dir={locale === "en" ? "ltr" : "rtl"}
      modules={[Autoplay]}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      spaceBetween={30}
      breakpoints={
        !fromCategory ? BrandHomeBreakPoints : BrandCategoryBreakPoints
      }
    >
      {data?.map((brand) => {
        return (
          <SwiperSlide className="py-1" key={uuidv4()}>
            <Link href={`/${handleStartWithSlashInUrl(brand?.url)}`}>
              <NextImage
                src={validateImgSrc(brand?.img)}
                className="h-16 aspect-[2/1] object-contain "
                alt="Brand"
                width={200}
                height={64}
              />
            </Link>
          </SwiperSlide>
        );
      })}
    </Swiper>
  ) : null;
};

export default BrandSwiper;
